module.exports = __webpack_public_path__ + "img/left.727e038c.webp";